import React, { useState } from "react";
import { Typography, Spin } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-hot-toast";
import "./login.css";
import LoadingSpinner from "./loader";
import { URL } from "../config";
import { LoginOutlined } from "@ant-design/icons";

const { Title } = Typography;


const LoginPage = () => {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const [buttonLoading, setButtonLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [loginText, setLoginText] = useState("Login");

 
const handleSubmit = async (e) => {
  e.preventDefault();

  if (!username || !password) {
    toast.error("Please enter username & password");
    return;
  }

  try {
    setButtonLoading(true);
    setLoginText("Please wait...");
    setPageLoading(true);

    const response = await axios.post(`${URL}/login`, {
      userName: username.trim(),
      password: password.trim(),
    });

   
    console.log(" Backend response:", response.data);

   
    let token = response.data.token;
    if (!token) token = response.data.accessToken; 
    if (!token) token = response.data.jwt; 

    const user = response.data.user || response.data.data || {};

    if (!token) {
      throw new Error("No token in response");
    }

    localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify(user));

    
    console.log("Saved token:", token.slice(0, 20) + "...");
    console.log("LocalStorage token:", localStorage.getItem("token"));

    toast.success("Login successful");
    setLoginText("Login Successfully");

    setTimeout(() => {
      setPageLoading(false);
      navigate("/dashboard/home", { replace: true });
    }, 1000);

  } catch (error) {
    console.error(" Login error:", error.response?.data || error.message);
    setPageLoading(false);
    setButtonLoading(false);
    setLoginText("Login");

    if (error.response?.status === 401) {
      toast.error("Invalid username or password");
    } else if (error.message === "No token in response") {
      toast.error("Server no token returned");
    } else {
      toast.error("Server error, try again");
    }
  } finally {
    setTimeout(() => {
      setButtonLoading(false);
      setLoginText("Login");
    }, 1500);
  }
};


  return (
    <>

      {pageLoading && <LoadingSpinner />}

      <div className="page-wrapper">
        <div className="login-card">
          
          <div className="login-image">
            <img src="/images/logo4.png" alt="login" />
            <div className="image-text">꧁༺स्वरसागरामृत परिवार༻꧂</div>
          </div>

      
          <div className="login-form">
            <div className="login-box">
              <Title level={2} className="login-title">
                Login
              </Title>

              <form onSubmit={handleSubmit}>
                <div className="field">
                  <UserOutlined className="field-icon" />
                  <input
                    type="text"
                    placeholder="User Name"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                  />
                </div>

                <div className="field">
                  <LockOutlined className="field-icon" />
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </div>

                <button className="login-btn" disabled={buttonLoading}>
  {buttonLoading ? (
    <Spin size="small" className="custom-white-spin" />
  ) : (
    <>
      <LoginOutlined style={{ marginRight: 8 ,fontSize: 18 }} />
      Login
    </>
  )}
</button>

              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginPage;
